module.exports = __webpack_public_path__ + "static/img/yt2.dc965ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/yt2.jpg
// module id = pY5t
// module chunks = 5